"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePerpetualOffer = void 0;
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const types_1 = require("../../../types");
const amm_helpers_1 = require("./amm_helpers");
const helpers_2 = require("./helpers");
const anchor_1 = require("@project-serum/anchor");
const removePerpetualOffer = ({ programId, connection, accounts, optimistic, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const [bondOfferVault, bondOfferVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_OFFER_VAULT_PREFIX), accounts.bondOfferV2.toBuffer()], program.programId);
    const [lenderLeaderboard, lenderLeaderboardBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.LENDER_LEADERBOARD_PREFIX),
        accounts.bondOfferV2.toBuffer(),
    ], program.programId);
    const [lenderWeeklyLeaderboard, lenderWeeklyLeaderboardBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.LENDER_WEEKLY_LEADERBOARD_PREFIX),
        constants_1.ENCODER.encode((0, helpers_2.currentLenderLeaderboardWeek)().toString()),
        accounts.bondOfferV2.toBuffer(),
    ], program.programId);
    instructions.push(yield program.methods
        .removePerpetualOffer()
        .accountsStrict({
        bondOfferV2: accounts.bondOfferV2,
        user: accounts.userPubkey,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        mutualBondTradeTxnVault,
        bondOfferVault,
        lenderLeaderboard: lenderLeaderboard,
        lenderWeeklyLeaderboard: lenderWeeklyLeaderboard
    })
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    const optimisticLeaderboardResult = optimistic
        ? (0, amm_helpers_1.optimisticUpdateLenderLeaderboards)(optimistic, lenderLeaderboard, lenderWeeklyLeaderboard, true, true)
        : undefined;
    const optimisticResult = optimistic
        ? {
            bondOffer: optimistic.bondOffer.pairState === types_1.PairState.PerpetualOnMarket
                ? (0, helpers_2.optimisticWithdrawFromBondOffer)(Object.assign(Object.assign({}, optimistic.bondOffer), { pairState: types_1.PairState.PerpetualClosed, lastTransactedAt: (0, helpers_2.nowInSeconds)() }), optimistic.bondOffer.fundsSolOrTokenBalance)
                : (0, amm_helpers_1.optimisticUpdateBondOfferBonding)({
                    bondOffer: Object.assign(Object.assign({}, optimistic.bondOffer), { pairState: types_1.PairState.PerpetualBondingCurveClosed, lastTransactedAt: (0, helpers_2.nowInSeconds)(), concentrationIndex: 0 }),
                    newDelta: 0,
                    newLoanValue: 0,
                    newQuantityOfLoans: 0,
                }),
            lenderLeaderboard: optimisticLeaderboardResult === null || optimisticLeaderboardResult === void 0 ? void 0 : optimisticLeaderboardResult.optimisticLenderLeaderboard,
            lenderWeeklyLeaderboard: optimisticLeaderboardResult === null || optimisticLeaderboardResult === void 0 ? void 0 : optimisticLeaderboardResult.optimisticLenderWeeklyLeaderboard,
        }
        : optimistic;
    return { account: null, instructions, signers, optimisticResult };
});
exports.removePerpetualOffer = removePerpetualOffer;
